import { JOB_STATUSES_ENUM } from '@constants/enums/jobStatuses';

export const jobCanBeResubmitted = (status: keyof typeof JOB_STATUSES_ENUM) => {
  return (
    JOB_STATUSES_ENUM[status] === JOB_STATUSES_ENUM.JOB_STATUS_ERROR ||
    JOB_STATUSES_ENUM[status] === JOB_STATUSES_ENUM.JOB_STATUS_PROCESSING
  );
};
